import type { ICheckboxFilterOption } from "app/pages/sales-intelligence/modules/advanced-search-filtering/components/filters/CheckboxFilter/types";

import type { LeadScoreFilterOption } from "./const";

export const normalizeLeadScoreFilterValue = (
    value?: readonly LeadScoreFilterOption[],
): readonly LeadScoreFilterOption[] => value ?? [];

export const getLeadScoreSelectedOptions = (
    options: readonly ICheckboxFilterOption<LeadScoreFilterOption>[],
    value?: readonly LeadScoreFilterOption[],
): readonly ICheckboxFilterOption<LeadScoreFilterOption>[] => {
    const normalizedValue = normalizeLeadScoreFilterValue(value);

    if (!normalizedValue.length) {
        return [];
    }

    return options.filter((option) => normalizedValue.includes(option.value));
};

export const isLeadScoreSelected = (
    score: LeadScoreFilterOption,
    currentValue?: readonly LeadScoreFilterOption[],
): boolean => normalizeLeadScoreFilterValue(currentValue).includes(score);

export const toggleLeadScoreSelection = (
    selectedItem: LeadScoreFilterOption,
    currentValue?: readonly LeadScoreFilterOption[],
): readonly LeadScoreFilterOption[] => {
    const normalizedValue = normalizeLeadScoreFilterValue(currentValue);
    const isSelected = normalizedValue.includes(selectedItem);

    return isSelected ? normalizedValue.filter((value) => value !== selectedItem) : [...normalizedValue, selectedItem];
};

export const addLeadScoreSelection = (
    score: LeadScoreFilterOption,
    currentValue?: readonly LeadScoreFilterOption[],
): readonly LeadScoreFilterOption[] => {
    const normalizedValue = normalizeLeadScoreFilterValue(currentValue);

    return normalizedValue.includes(score) ? normalizedValue : [...normalizedValue, score];
};

export const removeLeadScoreSelection = (
    id: LeadScoreFilterOption,
    currentValue?: readonly LeadScoreFilterOption[],
): readonly LeadScoreFilterOption[] => normalizeLeadScoreFilterValue(currentValue).filter((value) => value !== id);
